var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStakingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_255_5692",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.571289,
    y: 0.567383,
    width: 48.8571,
    height: 48.8571,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_255_5692)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2183 5.03975C26.2183 5.4031 25.9237 5.69766 25.5604 5.69766L19.598 5.69766C18.2918 5.69766 17.3517 5.69817 16.6133 5.7585C15.8826 5.8182 15.4076 5.93318 15.021 6.13015C14.2744 6.51058 13.6674 7.11761 13.2869 7.86424C13.09 8.25081 12.975 8.72582 12.9153 9.45652C12.8549 10.1949 12.8544 11.135 12.8544 12.4413L12.8544 15.7872L14.8153 13.8264C15.0722 13.5695 15.4888 13.5695 15.7457 13.8264C16.0026 14.0833 16.0026 14.4999 15.7457 14.7568L12.6617 17.8408C12.5384 17.9642 12.371 18.0335 12.1965 18.0335C12.022 18.0335 11.8547 17.9642 11.7313 17.8408L8.64735 14.7568C8.39042 14.4999 8.39042 14.0833 8.64735 13.8264C8.90428 13.5695 9.32085 13.5695 9.57778 13.8264L11.5386 15.7872L11.5386 12.4117C11.5386 11.1413 11.5386 10.1476 11.6038 9.34937C11.6702 8.5373 11.8073 7.86985 12.1145 7.26687C12.6211 6.27265 13.4294 5.46432 14.4236 4.95774C15.0266 4.65051 15.6941 4.51339 16.5061 4.44705C17.3044 4.38183 18.2981 4.38183 19.5685 4.38184L25.5604 4.38184C25.9237 4.38184 26.2183 4.67639 26.2183 5.03975Z",
    fill: "url(#paint0_linear_255_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6909 42.7591C24.6909 42.3957 24.9855 42.1012 25.3488 42.1012L31.3112 42.1012C32.6174 42.1012 33.5575 42.1007 34.2959 42.0403C35.0266 41.9806 35.5016 41.8656 35.8882 41.6687C36.6348 41.2883 37.2418 40.6812 37.6223 39.9346C37.8192 39.548 37.9342 39.073 37.9939 38.3423C38.0542 37.6039 38.0547 36.6638 38.0547 35.3576L38.0547 32.0116L36.0939 33.9724C35.837 34.2293 35.4204 34.2293 35.1635 33.9724C34.9066 33.7155 34.9066 33.2989 35.1635 33.042L38.2474 29.958C38.3708 29.8346 38.5382 29.7653 38.7127 29.7653C38.8871 29.7653 39.0545 29.8346 39.1779 29.958L42.2618 33.042C42.5188 33.2989 42.5188 33.7155 42.2618 33.9724C42.0049 34.2293 41.5883 34.2293 41.3314 33.9724L39.3706 32.0116L39.3706 35.3871C39.3706 36.6575 39.3706 37.6513 39.3054 38.4495C39.239 39.2615 39.1019 39.929 38.7947 40.532C38.2881 41.5262 37.4798 42.3345 36.4855 42.8411C35.8826 43.1483 35.2151 43.2854 34.403 43.3518C33.6048 43.417 32.6111 43.417 31.3407 43.417L25.3488 43.417C24.9855 43.417 24.6909 43.1224 24.6909 42.7591Z",
    fill: "url(#paint1_linear_255_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6475 27.5687C15.7049 27.5687 16.7624 27.5595 17.8198 27.5779C18.0037 27.5779 18.2427 27.6698 18.3715 27.8076C19.2266 28.6437 20.0817 29.4797 20.9001 30.3526C23.2724 32.8792 24.0172 35.8468 22.9414 39.1359C21.8747 42.4159 19.5668 44.4372 16.1555 45.0895C10.6109 46.1461 5.45257 41.5247 5.83876 35.9019C5.98588 33.7612 6.80423 31.9328 8.27542 30.3985C9.12135 29.5165 9.98568 28.6437 10.8684 27.7892C10.9971 27.6606 11.2362 27.5779 11.4293 27.5779C12.4959 27.5595 13.5717 27.5687 14.6475 27.5687ZM11.7603 37.8405C11.8706 39.2278 12.6338 40.0271 13.9487 40.3946C13.9487 40.8448 13.9487 41.2858 13.9487 41.7268C14.4176 41.7268 14.8314 41.7268 15.3004 41.7268C15.3004 41.4328 15.3187 41.1756 15.2912 40.9183C15.2452 40.5324 15.3555 40.3395 15.7693 40.2109C16.8819 39.8526 17.5807 38.6857 17.4428 37.5465C17.3049 36.3337 16.367 35.3966 15.1532 35.2679C14.8314 35.2312 14.5096 35.2496 14.1878 35.222C13.5901 35.1577 13.1487 34.6616 13.1395 34.0827C13.1212 33.4947 13.5441 32.9894 14.1326 32.8883C15.2268 32.6954 15.6957 32.9527 16.1463 34.0276C16.5693 34.0276 16.9922 34.0276 17.5347 34.0276C17.3784 33.5682 17.2773 33.1548 17.0934 32.7873C16.7256 32.0615 16.0543 31.7031 15.2912 31.4918C15.2912 31.3356 15.2912 31.2162 15.2912 31.0876C15.2912 29.9942 15.2912 29.985 14.2154 30.1045C14.105 30.1137 13.9487 30.2882 13.9303 30.3985C13.8935 30.7568 13.9211 31.1243 13.9211 31.4826C13.774 31.5286 13.6729 31.5653 13.5717 31.6021C12.358 32.0063 11.604 33.164 11.7787 34.3675C11.9534 35.6354 12.9465 36.5358 14.2429 36.6093C14.5188 36.6277 14.7946 36.6093 15.0705 36.6461C15.6682 36.7288 16.0819 37.2433 16.0727 37.8313C16.0635 38.4193 15.6222 38.9062 15.0337 38.9889C13.9119 39.1451 13.4798 38.897 13.0752 37.8405C12.6522 37.8405 12.2292 37.8405 11.7603 37.8405Z",
    fill: "url(#paint2_linear_255_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45215 21.7051C12.9094 21.7051 16.3208 21.7051 19.7689 21.7051C19.2907 23.0097 18.7942 24.2776 18.3529 25.5547C18.1873 26.0325 17.9851 26.207 17.4518 26.1978C15.4932 26.1611 13.5255 26.1703 11.567 26.1886C11.2268 26.1886 11.0521 26.106 10.9325 25.766C10.4728 24.4246 9.95787 23.0832 9.45215 21.7051Z",
    fill: "url(#paint3_linear_255_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6229 21.6532C30.9906 21.7059 27.149 17.802 27.1621 13.1529C27.1753 8.56312 31.0037 4.69876 35.6624 4.71195C40.2552 4.71854 44.1297 8.56312 44.1034 13.2452C44.077 17.835 40.2486 21.7257 35.6229 21.6532ZM39.5633 9.74354C39.5369 9.5457 39.4381 9.38743 39.2338 9.30171C38.9834 9.19619 38.8121 9.32808 38.6474 9.48635C36.407 11.7285 34.16 13.9706 31.9197 16.2193C31.6495 16.4897 31.6363 16.7469 31.8472 16.9711C32.0646 17.1887 32.3282 17.1821 32.5984 16.9117C34.8519 14.663 37.0989 12.4077 39.3458 10.159C39.4645 10.0403 39.5567 9.92159 39.5633 9.74354ZM35.1682 10.7261C35.1616 9.63143 34.2655 8.73458 33.1716 8.74118C32.1042 8.74777 31.1685 9.69737 31.1816 10.7591C31.2014 11.8538 32.0976 12.7242 33.2046 12.7242C34.3248 12.7176 35.1748 11.8604 35.1682 10.7261ZM36.0907 15.6258C36.0907 16.7535 36.9341 17.6042 38.0609 17.6042C39.1877 17.6042 40.0377 16.7469 40.0377 15.6258C40.0377 14.4916 39.1943 13.6475 38.0609 13.6475C36.9407 13.6541 36.0907 14.4982 36.0907 15.6258Z",
    fill: "url(#paint4_linear_255_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1747 9.72956C33.748 9.72297 34.196 10.1714 34.196 10.7451C34.1894 11.299 33.7545 11.7409 33.1944 11.7475C32.6278 11.7541 32.1797 11.3056 32.1797 10.7319C32.1863 10.1714 32.6146 9.73616 33.1747 9.72956Z",
    fill: "url(#paint5_linear_255_5692)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0656 14.628C38.6389 14.628 39.0804 15.0896 39.0672 15.6633C39.054 16.2173 38.6125 16.6525 38.0524 16.6525C37.4792 16.6525 37.0443 16.1975 37.0509 15.6172C37.064 15.0566 37.5055 14.6214 38.0656 14.628Z",
    fill: "url(#paint6_linear_255_5692)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_5692",
    x1: 26.2183,
    y1: 11.2077,
    x2: 8.45465,
    y2: 11.2077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8845B",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0603A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_5692",
    x1: 24.6909,
    y1: 36.5912,
    x2: 42.4545,
    y2: 36.5912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8845B",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0603A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_255_5692",
    x1: 14.6208,
    y1: 27.5664,
    x2: 14.6208,
    y2: 45.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_255_5692",
    x1: 14.6105,
    y1: 21.7051,
    x2: 14.6105,
    y2: 26.1982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_255_5692",
    x1: 35.6328,
    y1: 4.71191,
    x2: 35.6328,
    y2: 21.6542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_255_5692",
    x1: 33.1879,
    y1: 9.72949,
    x2: 33.1879,
    y2: 11.7475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_255_5692",
    x1: 38.0591,
    y1: 14.6279,
    x2: 38.0591,
    y2: 16.6525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7770E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakingIcon);
export default __webpack_public_path__ + "static/media/stakingIcon.eebd5f069479807f656dcc047f4877e2.svg";
export { ForwardRef as ReactComponent };